import { useQueries } from '@tanstack/react-query'
import { useFetch } from './useFetch'
import { getSuccessData } from './utils'

export type ProductsCountOptions = {
  searches: string[]
  enabled?: boolean
}

export function useProductsCount(options: ProductsCountOptions) {
  const { searches, enabled = true } = options

  const { fetcherWrapper } = useFetch()

  async function fetcher(search: string) {
    const url = new URL(`/api/products/count`, window.location.origin)
    url.search = search

    return fetcherWrapper(url, { timeout: 3000 })
      .then((r) => r.json())
      .catch(() => undefined)
  }

  function sum(data: (number | undefined)[]): number | undefined {
    if (data.length === 0) return undefined

    return data.reduce((prev, current) => {
      if (prev === undefined || current === undefined) return undefined

      return prev + current
    }, 0)
  }

  return useQueries({
    queries: searches.map((search) => ({
      queryKey: ['products-search', search],
      queryFn: () => fetcher(search),
      enabled,
      retry: false,
    })),
    combine: (results) => {
      const successfulData = getSuccessData(results)
      return {
        data: sum(successfulData),
        isLoading: results.some((r) => r.isLoading),
      }
    },
  })
}
